





import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class TableCard extends Vue {
  @Prop({ default: '200' })
  public width!: string;

  @Prop({ default: '200' })
  public height!: string;

  @Prop() public color!: string;
}
